// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__1X_rb","message":"CookieConsent_message__1IzeN","cookieLink":"CookieConsent_cookieLink__3p8g2","continueBtn":"CookieConsent_continueBtn__I9CRs"};